export default {"src":"/_next/static/media/ren.c57e9c61.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};